import { InformationCircleBold } from '@ha/icons';
import React from 'react';
import { Typography } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  infoLine: {
    display: 'flex',
    alignItems: 'baseline',
  },
  infoText: {
    color: theme.palette.grey[500],
    marginLeft: theme.spacing(1),
  },
  infoIcon: {
    fontSize: theme.typography.body1.fontSize,
    top: theme.spacing(0.3),
    position: 'relative',
  },
}));
const InfoLine: React.FC<{ description: React.ReactNode }> = ({
  description,
}) => {
  const { classes } = useStyles();
  return (
    <div className={classes.infoLine}>
      <InformationCircleBold className={classes.infoIcon} color="disabled" />
      <Typography.Paragraph className={classes.infoText}>
        {description}
      </Typography.Paragraph>
    </div>
  );
};

export { InfoLine };
